import Typography from "@mui/material/Typography";

const FieldCaption = ({ error, helperText = "" }) => {
  const message = error?.message || helperText;
  if (!message) return null;

  return (
    <Typography
      variant="caption"
      color={error?.message ? "error" : "text.secondary"}
      sx={{ display: "block", mt: 0.5 }}
    >
      {message}
    </Typography>
  );
};

export default FieldCaption;
